import httpClient from "@/plugins/axios";

export const getAlerts = async (type) => {
    const response = await httpClient.get('/v1/alerts/',
        {
            params: {
                type
            }
        }
    );
    return response;
}
